import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import cx from "classnames";
const SkipContent = (props) => {
  const {
    prefix = "",
    children,
    targetId,
    label,
    className,
    targetReference,
    linkReference,
    onKeyDown,
    ...other
  } = props;
  const baseClass = `${prefix}skip-content`;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "a",
      {
        href: `#${targetId}`,
        className: cx(`${baseClass}__button`, className),
        ref: linkReference,
        onKeyDown: (e) => {
          if (onKeyDown) {
            onKeyDown(e);
          }
          if (e.key === " ") {
            e.preventDefault();
            e.currentTarget.click();
          }
        },
        ...other,
        children: label
      }
    ),
    children,
    children && /* @__PURE__ */ jsx(
      "span",
      {
        id: targetId,
        className: cx(`${baseClass}__target`),
        tabIndex: -1,
        ref: targetReference
      }
    )
  ] });
};
SkipContent.displayName = "SkipContent";
export {
  SkipContent
};
